// Renders context tag chips for a task row using display-name lookup.
import TagChip from '@/components/ui/TagChip';

const TaskContextPills = ({
  allContexts,
  contextDisplayMap,
  dense = false,
}) => {
  if (!allContexts || allContexts.length === 0) return null;

  return (
    <>
      {allContexts.map((c) => {
        const name = contextDisplayMap.get(c.toLowerCase()) || c;
        return (
          <TagChip
            key={c}
            tag={`@${c}`}
            label={name}
            dense={dense}
            data-testid="task-item__context-chip"
          />
        );
      })}
    </>
  );
};

export default TaskContextPills;
